import * as d3 from "d3";
import isMobileDevice from "../../../../functions/mobileDevice";
import moment from "moment";

const homicideTimeline = (data, timePeriod) => {
  //Refresh Chart
  d3.select("#timeline svg svg").remove();
  d3.select("#timeline_container .tool_tip").remove();
  d3.selectAll("#timeline_labels p").remove();

  const parse_time = d3.timeParse("%m/%d/%Y"),
    margin = { top: 0, right: 0, bottom: 0, left: 30 },
    width = 700 - margin.left - margin.right,
    height = 250 - margin.top - margin.bottom,
    y = d3.scaleLinear().range([height, 0]),
    x = d3.scaleTime().range([0, width]).nice();

  x.domain([
    parse_time(`01/01/${+timePeriod}`),
    parse_time(`01/01/${+timePeriod + 1}`),
  ]);

  y.domain([0, d3.max(data, (d) => d[1])]);

  const svg = d3
    .select("#timeline .container")
    .append("svg")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

  const tooltip = d3
    .select("#timeline_container")
    .append("div")
    .attr("class", "tool_tip");

  const chart = svg.append("g").attr("class", "chart"),
    labels = svg.append("g").attr("class", "labels"),
    overlay = svg.append("g").attr("class", "overlay");

  chart
    .selectAll("rect")
    .data(data)
    .enter()
    .append("rect")
    .attr("class", (d) => d3.timeFormat("%B%d%Y")(parse_time(d[0])))
    .attr("y", (d) => y(d[1]))
    .attr("x", (d) => x(parse_time(d[0])))
    .attr("width", 2)
    .attr("height", (d) => height - y(d[1]))
    .style("fill", "#fac9c7");

  function get_seven_day_avg(i) {
    const withinSeven = moment(data[i][0]).subtract(6, "days").calendar();
    const getSum = (total, d) => total + d[1];
    const past7 = data
      .filter(
        (d, j) =>
          j <= i &&
          j > i - 7 &&
          parse_time(data[j][0]) >= parse_time(withinSeven)
      )
      .reduce(getSum, 0);
    return past7 / 7;
  }

  const line = d3
    .line()
    .curve(d3.curveStepAfter)
    .x((d) => x(parse_time(d[0])))
    .y((d, i) => y(get_seven_day_avg(i)));

  data.sort((a, b) => (parse_time(a[0]) < parse_time(b[0]) ? -1 : 1));

  var dateStart = moment(data[0][0]);
  var dateEnd = moment(data[data.length - 1][0]);
  var timeValues = [];
  while (dateEnd > dateStart || dateStart.format("M") === dateEnd.format("M")) {
    timeValues.push(dateStart.format("MM/DD/YYYY"));
    dateStart.add(1, "month").startOf("month");
  }

  timeValues.map((val, i) => {
    // console.log(val);
    const pctLeft = (x(parse_time(val)) / width) * 100;
    d3.select("#timeline_date_labels")
      .append("p")
      .html(() => {
        if (d3.timeFormat("%b")(parse_time(val)) === "Jan") {
          return d3.timeFormat("%b. '%y")(parse_time(val));
        } else {
          return d3.timeFormat("%b.")(parse_time(val));
        }
      })
      .attr("class", i % 2 ? "odd date_labels" : "even date_labels")
      .style("bottom", "-2px")
      .style("left", pctLeft + "%");
  });

  chart
    .selectAll(".tip_rect")
    .data(data)
    .enter()
    .append("rect")
    .attr("class", (d) => `tip_${d3.timeFormat("%B%d%Y")(parse_time(d[0]))}`)
    .attr("y", (d, i) => y(get_seven_day_avg(i)))
    .attr("x", (d) => x(parse_time(d[0])))
    .attr("width", 2)
    .attr("height", (d, i) => height - y(get_seven_day_avg(i)))
    .style("fill", "rgba(0,0,0,0)");

  chart
    .append("path")
    .datum(data)
    .attr("fill", "none")
    .style("stroke", "#cf1111")
    .attr("stroke-linejoin", "round")
    .attr("stroke-linecap", "round")
    .attr("stroke-width", 2)
    .attr("d", line);

  let prevHighlight;

  const highest_homicide_val = d3.max(data, (d, i) => get_seven_day_avg(i));
  let highest_index;
  data.map((d, i) => {
    if (get_seven_day_avg(i) === highest_homicide_val) {
      highest_index = i;
    }
  });

  d3.select("#timeline_labels")
    .append("p")
    .style("position", "absolute")
    .style("font-family", "arial")
    .style("color", "#000")
    .style("font-weight", "bold")
    .style("font-size", "14px")
    .text("7-day average")
    .style("z-index", 500)
    .style(
      "top",
      (y(get_seven_day_avg(highest_index)) / height) * 100 - 20 + "%"
    )
    .style("left", (x(parse_time(data[highest_index][0])) / width) * 100 + "%");

  chart
    .append("line")
    .attr("stroke-width", 1)
    .attr("stroke", "#333")
    .attr("x1", x(parse_time(data[highest_index][0])))
    .attr("x2", x(parse_time(data[highest_index][0])))
    .attr("y1", y(get_seven_day_avg(highest_index)) - 15)
    .attr("y2", y(get_seven_day_avg(highest_index)) - 2);

  const index = d3.local(); // Local variable for storing the index.
  overlay
    .selectAll("rect")
    .data(data)
    .enter()
    .append("rect")
    .each(function (d, i) {
      index.set(this, i); // Store index in local variable.
    })
    .attr("class", (d) => d3.timeFormat("%B%d%Y")(parse_time(d[0])))
    .attr("y", 0)
    .attr("x", (d) => x(parse_time(d[0])))
    .attr("width", 2)
    .attr("height", height)
    .style("fill", "rgba(0,0,0,0)")
    .on("mouseout", function () {
      if (isMobileDevice()) {
        return;
      }
      if (prevHighlight) {
        prevHighlight.style("fill", "#fac9c7");
      }
      tooltip.style("display", "none");
    })
    .on("mousemove", function (event, d) {
      if (isMobileDevice()) {
        return;
      }
      if (prevHighlight) {
        prevHighlight.style("fill", "#fac9c7");
      }
      const selectedClass = event.currentTarget.classList.value;
      d3.select(`.chart .${selectedClass}`).style("fill", "#cf1111");
      prevHighlight = d3.select(`.chart .${selectedClass}`);
      const matrix = document
        .querySelector(`.chart .tip_${selectedClass}`)
        .getBoundingClientRect();
      tooltip
        .style("display", "inline-block")
        .html(
          `<div class="toolTip_body"><p class="date_tip">${d3.timeFormat(
            "%B %e, %Y"
          )(parse_time(d[0]))}</p><p><span>Homicides: </span>${d3.format(",")(
            d[1]
          )}</p><p>7-day average: ${get_seven_day_avg(index.get(this)).toFixed(
            1
          )}</p></div>`
        )
        .style("left", () => {
          const svg_width = document
            .querySelector(`#timeline svg`)
            .getBoundingClientRect().width;
          const tooltip_width = document
            .querySelector(`.tool_tip`)
            .getBoundingClientRect().width;
          if (
            window.innerWidth -
              (window.innerWidth - svg_width) / 2 -
              event.pageX >
            150
          ) {
            d3.select(".toolTip_body").classed("toolTip_body_r", false);
            d3.select(".toolTip_body").classed("toolTip_body_l", true);
            return event.pageX - 20 + "px";
          } else {
            d3.select(".toolTip_body").classed("toolTip_body_r", true);
            d3.select(".toolTip_body").classed("toolTip_body_l", false);
            return event.pageX - tooltip_width + 15 + "px";
          }
        })
        .style("top", () => {
          const tooltip_height = document
            .querySelector(`.tool_tip`)
            .getBoundingClientRect().height;
          return matrix.y + window.scrollY - tooltip_height - 15 + "px";
        });
    });

  const yAxis = d3.axisLeft(y);
  yAxis
    .scale()
    .ticks(3)
    .map((d, i) => {
      d3.select("#timeline_homicide_labels")
        .append("p")
        .text(i === yAxis.scale().ticks(3).length - 1 ? d + " homicides" : d)
        .attr("class", d === 0 ? "zero_label" : "labels")
        .style("top", (y(d) / height) * 100 + "%")
        .style("left", 0);
    });
};

export default homicideTimeline;
